"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BanksList = require("./BanksList");
Object.keys(_BanksList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BanksList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BanksList[key];
    }
  });
});